import React from 'react';
import { Quote } from '../../../../api/quotes';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';

interface QuotesTableRowProps {
    quote: Quote;
    onView: () => void;
}

const PLAN_MAP: Record<string, string> = {
    'core': 'Core',
    'plus': 'Plus',
    'scan': 'Scan',
    'free': 'Free'
};

const QuotesTableRow: React.FC<QuotesTableRowProps> = ({
    quote,
    onView
}) => {
    const actionOptions = [
        { key: 'view', value: 'View/Edit' }
    ];

    const handleAction = (id: any, action: string) => {
        if (action === 'view') {
            onView();
        }
    };

    return (
        <div className='table-row'>
            <div className='table-cell'>{quote.quote}</div>
            <div className='table-cell'>
                {(quote.plans || []).length > 0
                    ? (quote.plans || []).map((plan: string) => PLAN_MAP[plan] || plan).join(', ')
                    : '-'}
            </div>
            <div className='table-cell actions'>
                <TableRowActionMenu
                    id={quote.id}
                    options={actionOptions}
                    onActionMenuClick={handleAction}
                />
            </div>
        </div>
    );
};

export default QuotesTableRow;
